import * as envVars from '@/env-vars';

export const getEnvVar = function(variableName) {
	let variableValue = envVars[variableName];
	if(variableValue === undefined) {
		throw `Variable de entorno '${variableName}' no está definida`;
	}
	return variableValue;
};
